import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
// SUGESTÃO: O fluxo de login de médico (UF/CRM) está em LoginView.vue.
// LoginLayout.vue parece ser para outro tipo de usuário (CPF).
// Considere usar LoginView como a rota principal.
import Login from '../views/LoginView.vue'
import HomeMedico from '../views/HomeMedico.vue'
import AutoLogin from '../views/AutoLogin.vue'

const routes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/auto-login',
    name: 'auto-login',
    component: AutoLogin
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView
  },
  {
    path: '/homeMedico',
    name: 'medico',
    component: HomeMedico
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
